import { render, staticRenderFns } from "./AiSuggestionDirectCostParser.vue?vue&type=template&id=12c8ab19"
import script from "./AiSuggestionDirectCostParser.vue?vue&type=script&lang=js"
export * from "./AiSuggestionDirectCostParser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports